import { CostCenterSelect } from './CostCenterSelect';
import { CustomFieldSelect } from './CustomFieldSelect';
import { ExpenseCategorySelect } from './ExpenseCategorySelect';
import { SpendTypeSelect } from './SpendTypeSelect';
import { TeamSelect } from './TeamSelect';
import { type Dimension } from '../../approvalWorkflow';

type Props = {
  dimension: Dimension;
  selectedValues: { id: string; name: string }[] | undefined | null;
  onSelect: (values: { id: string; name: string }[] | null) => void;
  mode: 'create' | 'edit';
};

export const DimensionValuesSelect = ({
  dimension,
  selectedValues,
  onSelect,
  mode,
}: Props) => {
  if (dimension.type === 'spendType') {
    return (
      <SpendTypeSelect
        selectedValues={selectedValues}
        onSelect={onSelect}
        mode={mode}
      />
    );
  }
  if (dimension.type === 'costCenter') {
    return (
      <CostCenterSelect
        selectedValues={selectedValues}
        onSelect={onSelect}
        mode={mode}
      />
    );
  }
  if (dimension.type === 'team') {
    return (
      <TeamSelect
        selectedValues={selectedValues}
        onSelect={onSelect}
        mode={mode}
      />
    );
  }
  if (dimension.type === 'customField') {
    return (
      <CustomFieldSelect
        selectedValues={selectedValues}
        onSelect={onSelect}
        mode={mode}
        customFieldId={dimension.customFieldId}
      />
    );
  }
  if (dimension.type === 'expenseCategory') {
    return (
      <ExpenseCategorySelect
        selectedValues={selectedValues}
        onSelect={onSelect}
        mode={mode}
      />
    );
  }
  return null;
};
